import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

// demo - external link
// <MenuLink
//   path="https://www.google.com"
//   search={this.props.location ? this.props.location.search : null}
//   textId="Sign in"
//   onClick={this.onMenuItemClick}
//   isExternal
//   isSsr={false}
// />

const MenuLink = props => {
  const {
    id,
    className,
    isCurrent,
    path,
    search,
    textId,
    onClick,
    isExternal,
    isSsr = false,
  } = props;
  const itemClass = classNames(className, { current: isCurrent });
  return (
    <li key={id} className={`${id} ${itemClass}`}>
      {link(id, path, search, textId, onClick, isExternal, isSsr)}
    </li>
  );
};

const link = (id, path, search, textId, onClick, isExternal, isSsr) => {
  if (!path) {
    return (
      <span data-id={id} onClick={onClick}>
        <FormattedMessage id={textId} description={textId} />
      </span>
    );
  }
  if (isExternal) {
    return (
      <a
        href={path}
        data-id={id}
        onClick={onClick}
        target="_blank"
        rel="noopener noreferrer"
      >
        <FormattedMessage id={textId} description={textId} />
      </a>
    );
  }
  if (isSsr) {
    return (
      <a data-id={id} href={path} onClick={onClick}>
        <FormattedMessage id={textId} description={textId} />
      </a>
    );
  }
  return (
    <Link
      to={{
        pathname: path,
        search,
      }}
      data-id={id}
      onClick={onClick}
    >
      <FormattedMessage id={textId} description={textId} />
    </Link>
  );
};

MenuLink.defaultProps = {
  path: null,
  search: null,
  textId: null,
  onClick: null,
  isExternal: false,
  isSsr: false,
  className: null,
  isCurrent: false,
  id: null,
};

MenuLink.propTypes = {
  path: PropTypes.string,
  search: PropTypes.string,
  textId: PropTypes.string,
  onClick: PropTypes.func,
  isExternal: PropTypes.bool,
  isSsr: PropTypes.bool,
  className: PropTypes.string,
  isCurrent: PropTypes.bool,
  id: PropTypes.string,
};

export default MenuLink;
